export default {
  de: {
    sty: "Standort",
    delivery: {
      number: 'Nr.'
    },
    printCredits: 'Gutschriften drucken',
    notification: {
      update: {
        type: 'success',
        message: 'Standort erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      }
    }
  }
}
